import type { LucideIcon } from 'lucide-react';

// Shared placeholder for empty lists — icon, bold title, muted
// description. Extracted from the Forms page empty state so every list
// page reads the same. Render inside the list body (or a full-width
// table cell for <table> layouts).
export function EmptyState({
  icon: Icon,
  title,
  description,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
}) {
  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center px-5 py-16 text-center">
      <Icon className="mx-auto h-8 w-8 text-muted-foreground/60" aria-hidden />
      <h2 className="mt-4 font-sans text-[16px] font-semibold text-foreground">
        {title}
      </h2>
      <p className="mx-auto mt-2 max-w-md font-mono text-[11px] leading-relaxed text-muted-foreground">
        {description}
      </p>
    </div>
  );
}
